import { Location } from "@/src/models/location";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getAllLocations(): Promise<Location[]> {
  return fetchJSON<Location[]>("/api/locations");
}

export async function getLocationById(locationId: string): Promise<Location | null> {
  return fetchJSON<Location>(`/api/locations/${locationId}`);
}
